import React, { useState } from "react";
import { Typography, Stack, Chip, Box, useTheme } from "@mui/material";
import { useForm } from "react-hook-form";
import "./index.css";
import TextInput from "../../../components/TextInput";
import { useDispatch, useSelector } from "react-redux";
import { setOnboarding } from "../../../rtkSlices/onboardingSlice";

const initialCommunication = {
  toneOfVoice: [
    { id: 1, name: "Casual", selected: false },
    { id: 2, name: "Formal", selected: false },
    { id: 3, name: "Friendly and Conversational", selected: false },
    { id: 4, name: "Witty & Humorous", selected: false },
    { id: 5, name: "Empathic and Supportive", selected: false },
  ],
  purposeAndFormat: [
    { id: 1, name: "Persuasive & Sales-oriented", selected: false },
    { id: 2, name: "Instructional & How-to", selected: false },
    { id: 3, name: "Technical & Analytical", selected: false },
    { id: 4, name: "Concise & Bullet-pointed", selected: false },
  ],
  creativeAndNarrative: [
    { id: 1, name: "Storytelling & Narrative", selected: false },
    { id: 2, name: "Motivational & Inspirational", selected: false },
    { id: 3, name: "Poetic & Lyrical", selected: false },
    { id: 4, name: "Creative & Imaginative", selected: false },
  ],
  professionalAndAcademic: [
    { id: 1, name: "Corporate & Business", selected: false },
    { id: 2, name: "Academic & Research-style", selected: false },
    { id: 3, name: "Journalistic & News-style", selected: false },
    { id: 4, name: "SEO-friendly & Keyword-focused", selected: false },
  ],
};

const boQuestions = [
  {
    question: "How detailed would you like Bo's responses to be?",
    type: "chooseOne",
    options: [
      { name: "Short and concise", selected: false },
      { name: "Balanced and moderate length", selected: false },
      { name: "Detailed and comprehensive", selected: false },
    ],
  },
  {
    question: "Do you like Bo to occasionally use humor in responses?",
    type: "chooseOne",
    options: [
      { name: "Frequently—I enjoy a fun, playful approach", selected: false },
      {
        name: "Occasionally—just enough to keep things light",
        selected: false,
      },
      { name: "Rarely—I prefer a more serious tone", selected: false },
      { name: "Never—please avoid humor completely", selected: false },
    ],
  },
  {
    question: "How do you best absorb and retain information?",
    type: "chooseOne",
    options: [
      { name: "Visual explanations (charts, diagrams)", selected: false },
      { name: "Written explanations (step-by-step text)", selected: false },
      { name: "Practical examples and analogies", selected: false },
      { name: "Summaries and quick reference points", selected: false },
    ],
  },
  {
    question:
      "Should Bo occasionally check in on how you're feeling or proactively provide emotional support?",
    type: "trueOrFalse",
    selected: "",
    options: [],
  },
  {
    question:
      "Would you like Bo to proactively suggest new ideas or content related to your selected interests?",
    type: "trueOrFalse",
    selected: "",
    options: [],
  },
  {
    question:
      "Any cultural or regional details you'd like Bo to remember to make interactions more relevant?",
    type: "openField",
    answer: "",
    options: [],
  },
  {
    question: "Are there any sensitive topics you’d like to avoid?",
    type: "openField",
    answer: "",
    options: [],
  },
  {
    question: "Any other info you want Bo to remember about you?",
    type: "openField",
    answer: "",
    options: [],
  },
];

const CommunicationPreferences = (props: { boresponse: boolean }) => {
  const dispatch = useDispatch();
  const onboarding = useSelector((state: any) => state.onboarding.onboarding);
  const fetchedCommunication =
    onboarding && onboarding.communicationPreferences;
  const fetchedQuestions = onboarding && onboarding.questions;
    const theme = useTheme()
  const selectInitialCommunication = () => {
    const tempCommunication: any = { ...initialCommunication };
    Object.keys(fetchedCommunication)
      .filter((k) => k != "other")
      .forEach((comm: any) => {
        if (fetchedCommunication[comm].length) {
          fetchedCommunication[comm].forEach((g: any) => {
            if (
              tempCommunication[comm].find(
                (tempcomm: any) => tempcomm.name == g
              )
            ) {
              tempCommunication[comm].find(
                (tempcomm: any) => tempcomm.name == g
              ).selected = true;
            }
          });
        }
      });
    return tempCommunication;
  };
  const selectInitialQuestions = () => {
    const tempQuestions: any = [...boQuestions];
    Object.keys(fetchedQuestions).forEach((q) => {
      const ind = parseInt(q[1]) - 1;
      if (tempQuestions[ind].type == "chooseOne") {
        if (
          tempQuestions[ind].options.find(
            (o: any) => o.name == fetchedQuestions[q]
          )
        ) {
          tempQuestions[ind].options.find(
            (o: any) => o.name == fetchedQuestions[q]
          ).selected = true;
        }
      } else if (tempQuestions[ind].type == "trueOrFalse") {
        tempQuestions[ind].selected =
          fetchedQuestions[q] == true ? "yes" : "no";
      } else {
        tempQuestions[ind].answer = fetchedQuestions[q];
      }
    });
    return tempQuestions;
  };
  const [communication, setCommunication] = useState<
    typeof initialCommunication
  >(selectInitialCommunication);
  const [boresponse, setBoresponse] = useState<typeof boQuestions>(
    selectInitialQuestions
  );

  const MAX_OTHER_COMM_LEN = 160;

  const [otherCommText, setOtherCommText] = useState(
    fetchedCommunication.other || ""
  );

  function camelToPascalWithSpaces(input: string): string {
    // Insert space before each capital letter
    const spaced = input.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Capitalize the first letter of each word
    const pascal = spaced.replace(/\b\w/g, (char) => char.toUpperCase());

    return pascal;
  }

  const selectCommunication = (index: number, type: string) => {
    let tempCommunication: any = { ...communication };
    const selectedCommunication = tempCommunication[type][index];
    tempCommunication[type][index].selected = !selectedCommunication.selected;
    setCommunication(tempCommunication);
    const tempOnboarding = JSON.parse(JSON.stringify(onboarding));
    dispatch(
      setOnboarding({
        communicationPreferences: {
          ...tempOnboarding.communicationPreferences,
          [type]: tempCommunication[type]
            .filter((work: any) => work.selected)
            .map((work: any) => work.name),
        },
      })
    );
  };

  const selectBoAnswer = (index: number, optionIndex: number | string) => {
    let tempQuestions = [...boQuestions];
    const tempOnboarding = JSON.parse(JSON.stringify(onboarding));
    if (typeof optionIndex == "number") {
      tempQuestions[index].options.forEach((q) => (q.selected = false));
      tempQuestions[index].options[optionIndex].selected =
        !tempQuestions[index].options[optionIndex].selected;
      dispatch(
        setOnboarding({
          questions: {
            ...tempOnboarding.questions,
            [`q${index + 1}`]: tempQuestions[index].options[optionIndex].name,
          },
        })
      );
    } else {
      tempQuestions[index].selected = optionIndex;
      dispatch(
        setOnboarding({
          questions: {
            ...tempOnboarding.questions,
            [`q${index + 1}`]: optionIndex == "yes" ? true : false,
          },
        })
      );
    }
    setBoresponse(tempQuestions);
  };

  const handleOtherInterests = (e: any, ind: number) => {
    const tempOnboarding = JSON.parse(JSON.stringify(onboarding));
    const newWorkStatus = e.target.value;
    // tempOnboarding.interests.other = newWorkStatus;
    tempOnboarding.questions[`q${ind + 1}`] = newWorkStatus;
    dispatch(setOnboarding(tempOnboarding));
  };

  const handleOtherCommunication = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newText = e.target.value;
    setOtherCommText(newText);                     // live counter

    const temp = JSON.parse(JSON.stringify(onboarding));
    temp.communicationPreferences.other = newText;
    dispatch(setOnboarding(temp));
  };

  return (
    <Box className="communication-section">
      <Typography
        fontSize={"53px"}
        fontFamily={"Fredoka"}
        fontWeight={"600"}
        textAlign={"center"}
      >
        Your Communication Preferences
      </Typography>
      <Typography
        fontSize={"16px"}
        fontFamily={"Poppins"}
        fontWeight={"300"}
        marginTop={"5px"}
        textAlign={"center"}
      >
        How do you want Bo to talk to you?
      </Typography>
      <br />
      {!props.boresponse ? <br /> : null}
      {!props.boresponse
        ? (
            Object.keys(communication) as (keyof typeof initialCommunication)[]
          ).map((comm, ind) => {
            return (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "column",
                }}
              >
                <Typography
                  fontSize={"18px"}
                  fontFamily={"Poppins"}
                  fontWeight={"600"}
                >
                  {camelToPascalWithSpaces(comm)}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    borderRadius: 2,
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  {communication[comm].map((selection: any, index) => {
                    return (
                      <Chip
                        label={selection.name}
                        variant="outlined"
                        //   onClick={() => selectGoal(selection.id)}
                        sx={{
                          margin: "7px",
                          marginLeft: "0px",
                          borderColor: "rgba(42, 148, 95, 1)",
                        }}
                        className={selection.selected ? "selected-option" : ""}
                        onClick={() => selectCommunication(index, comm)}
                      />
                    );
                  })}
                </Box>
                <br />
                {ind == 3 ? (
                  <Box sx={{ width: "100%" }}>
                    <Typography
                      fontSize={"18px"}
                      fontFamily={"Poppins"}
                      fontWeight={"600"}
                      //   sx={{ flex: resp.type == "trueOrFalse" ? "none" : "auto" }}
                    >
                      Other
                    </Typography>
                    <TextInput
                      label={"Additional communication preferences"}
                      width="360px"
                      maxLength={MAX_OTHER_COMM_LEN}
                      helperText={`${otherCommText.length}/${MAX_OTHER_COMM_LEN}`}
                      handleChange={handleOtherCommunication}
                      defaultValue={fetchedCommunication.other}
                      color={theme.palette.primary.main}
                    />
                  </Box>
                ) : null}
              </Box>
            );
          })
        : boresponse.map((resp, ind) => {
            return (
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: resp.type != "trueOrFalse" ? "left" : "center",
                  flexDirection: resp.type != "trueOrFalse" ? "column" : "row",
                  WebkitFlexWrap:
                    resp.type != "trueOrFalse" ? "wrap" : "nowrap",
                  marginTop: ind == 4 ? "10px" : 0,
                }}
              >
                {ind == 5 ? <br /> : null}
                <Typography
                  fontSize={"18px"}
                  fontFamily={"Poppins"}
                  fontWeight={"600"}
                  //   sx={{ flex: resp.type == "trueOrFalse" ? "none" : "auto" }}
                >
                  {resp.question}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    borderRadius: 2,
                    alignItems: "flex-start",
                    width: "100%",
                    flex: resp.type == "trueOrFalse" ? 1 : "auto",
                  }}
                >
                  {resp.type == "chooseOne" ? (
                    resp.options.map((selection: any, index) => {
                      return (
                        <Chip
                          label={selection.name}
                          variant="outlined"
                          onClick={() => selectBoAnswer(ind, index)}
                          sx={{
                            margin: "7px",
                            marginLeft: "0px",
                            borderColor: "rgba(42, 148, 95, 1)",
                          }}
                          className={
                            selection.selected ? "selected-option" : ""
                          }
                        />
                      );
                    })
                  ) : resp.type == "trueOrFalse" ? (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <Chip
                        label={"Yes"}
                        variant="outlined"
                        onClick={() => selectBoAnswer(ind, "yes")}
                        sx={{
                          margin: "7px",
                          marginLeft: "0px",
                          borderColor: "rgba(42, 148, 95, 1)",
                          width: "50px",
                          //   flex: 1,
                        }}
                        className={
                          resp.selected == "yes" ? "selected-option" : ""
                        }
                      />
                      <Chip
                        label={"No"}
                        variant="outlined"
                        onClick={() => selectBoAnswer(ind, "no")}
                        sx={{
                          margin: "7px",
                          marginLeft: "0px",
                          borderColor: "rgba(42, 148, 95, 1)",
                          width: "50px",
                          //   flex: 1,
                        }}
                        className={
                          resp.selected == "no" ? "selected-option" : ""
                        }
                      />
                    </Box>
                  ) : (
                    <Box sx={{ width: "100%", marginTop: "8px" }}>
                    <TextInput
                              label={"Additional preferences"}
                              width="100%"
                              maxLength={MAX_OTHER_COMM_LEN}
                              helperText={`${otherCommText.length}/${MAX_OTHER_COMM_LEN}`}
                              handleChange={handleOtherCommunication}
                              defaultValue={fetchedCommunication.other}
                              color={theme.palette.primary.main}
                            />
                    </Box>
                  )}
                </Box>
                <br />
              </Box>
            );
          })}

      <br />
    </Box>
  );
};

export default CommunicationPreferences;
